import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { useEffect, useRef, useState } from 'react';

interface Props {
  openDialog: boolean;
  title: string;
  defaultValue: string | undefined;
  message: string;
  handleConfirm: (result: boolean, inputData: string | undefined) => void;
}
export default function InputDialog(props: Props) {
  const { openDialog, title, defaultValue, message, handleConfirm } = props;

  const [open, setOpen] = React.useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  // 入力値
  const [inputData, setInputData] = useState(defaultValue);
  const inputDataRef = useRef<any>(null);
  const handleInputDataChange = (e: any) => {
    e.preventDefault();
    // エラーチェック
    if (inputDataRef.current.value.trim() === '') {
      setButtonDisable(true);
    } else {
      setInputData(inputDataRef.current.value);
      setButtonDisable(false);
    }
  };

  useEffect(() => {
    setOpen(openDialog);
    setButtonDisable(false);
  }, [openDialog]);

  // ボタン
  const [buttonDisable, setButtonDisable] = useState(false);
  const handleOk = () => {
    setOpen(false);
    setButtonDisable(true);
    handleConfirm(true, inputData);
  };
  const handleClose = () => {
    setOpen(false);
    handleConfirm(false, undefined);
  };

  return (
    <div>
      <Dialog fullScreen={fullScreen} open={open} onClose={handleClose}>
        <DialogContent>
          <DialogContentText>{message}</DialogContentText>
          <TextField
            autoFocus
            margin='dense'
            id='inputData'
            label={title}
            type='text'
            fullWidth
            variant='standard'
            defaultValue={defaultValue}
            inputRef={inputDataRef}
            onChange={handleInputDataChange}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} disabled={buttonDisable}>
            キャンセル
          </Button>
          <Button onClick={handleOk} disabled={buttonDisable}>
            登録
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
